import React from "react";
import { shape, bool } from "prop-types";
import { Box, Container, Stack } from "@mui/material";
import ToolCard from "./ToolCard";
import WrappedProgressIndicator from "./WrappedProgressIndicator";

import { connectToState } from "../redux/connect-api";
import { platformConfig } from "shared/platform/config";
import { sectionStyles } from "shared/theme/styles";

const ToolSelector = ({ profileData = null, loading }) => {
  if (loading) {
    return <WrappedProgressIndicator loading={loading} />;
  }

  const toolAccessible = (toolId) => profileData?.[`${toolId}_access`];

  return (
    <Box
      component="section"
      sx={{
        ...sectionStyles,
        minHeight: "auto",
        marginBottom: "25px",
        "@media (min-height: 900px)": {
          marginBottom: "30px",
        },
      }}
    >
      <Container>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={3}
          sx={(theme) => ({
            marginTop: "-70px",
            [theme.breakpoints.up("md")]: {
              marginTop: "-70px",
              "@media (min-height: 900px)": {
                marginTop: "-140px",
              },
            },
          })}
        >
          {platformConfig.tools.map((tool, i) => (
            <Box
              key={i}
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 50%" },
                display: "flex",
                textAlign: "initial",
                "&:hover *": {
                  textDecoration: "none",
                },
              }}
            >
              <ToolCard tool={tool} accessible={toolAccessible(tool.id)} />
            </Box>
          ))}
        </Stack>
      </Container>
    </Box>
  );
};

ToolSelector.propTypes = {
  profileData: shape({
    ec_access: bool,
    im_access: bool,
  }),
  loading: bool,
};

const mapStateToProps = (state) => {
  return {
    loading: state.userProfile.loading,
    profileData: state.userProfile.data,
  };
};

export default connectToState(mapStateToProps)(ToolSelector);
